export enum ManageCapTransactionsTableColumn {
	id = 'id',
	date = 'date',
	securityIds = 'securityIds',
	types = 'types',
	titles = 'titles',
	noType = 'noType',
	destinationIds = 'destinationIds',
	sourceIds = 'sourceIds',
	sourcePersonId = 'sourceId',
	destinationPersonId = 'destinationId',
	boughtForIds = 'boughtForIds',
	soldForIds = 'soldForIds',
	amount = 'units',
	price = 'cost',
	isTransactionValid = 'isTransactionValid',
	isPossibleRedemption = 'isPossibleRedemption',
	transactionError = 'transactionError',
	sourceBalance = 'sourceBalanceNonStrict',
	sourceBalanceNew = 'sourceBalanceNew',
	destBalance = 'destBalanceNonStrict',
	destBalanceNew = 'destBalanceNew',
	order = 'order',
	buyerMipIds = 'buyerMipIds',
	sellerMipIds = 'sellerMipIds',
}
